import { recordPath, recordRoute } from '@/shared/registry'

/** Where the subscription plan pages live. */
export const plansPath = '/entitlements/plans'
export const createPlanPath = `${plansPath}/new`
export const planRoute = recordRoute('entitlements', 'plans')
export const editPlanRoute = `${planRoute}/edit`

/** A plan's details page. */
export function planPath(id: string): string {
  return recordPath('entitlements', 'plans', id)
}

/** A plan's edit page. */
export function editPlanPath(id: string): string {
  return `${planPath(id)}/edit`
}

/** The base of Plan Details' slots (`detailsSlots`). */
export const planDetailsSlot = 'entitlements.plan-details'

/** The permissions the plan screens show or hide their actions and fields by. */
export const readPlansPermission = 'entitlements.subscription-plans.read'
export const writePlansPermission = 'entitlements.subscription-plans.write'
export const deletePlansPermission = 'entitlements.subscription-plans.delete'
export const allOrganizationsPlansPermission = 'entitlements.subscription-plans.all-organizations.write'
export const readPlanPricingPermission = 'entitlements.subscription-plans.pricing.read'
export const writePlanPricingPermission = 'entitlements.subscription-plans.pricing.write'

/** The API's plan endpoints. */
export const plansApi = '/entitlements/v1/plans'

export function planApi(id: string): string {
  return `${plansApi}/${encodeURIComponent(id)}`
}

/** What a new plan of an organization starts with. */
export function planDefaultsApi(organizationId: string): string {
  return `${plansApi}/defaults?organizationId=${encodeURIComponent(organizationId)}`
}

/** The plans a course is in. */
export function coursePlansApi(courseId: string): string {
  return `/entitlements/v1/courses/${encodeURIComponent(courseId)}/plans`
}
